export const GeneralSettingList = [
    'company_name',
    'company_email',
    'company_phone',
    'company_phone_2',
    'company_website',
    'company_city',
    'company_state',
    'company_country_code',
    'company_zip_code',
    'company_address',
    'site_default_currency',
    'site_default_currency_symbol',
    'site_currency_position',
    'site_email_verification',
    'site_phone_verification',
    'site_digit_after_decimal_point',
    'site_google_map_key',
    'site_copyright',
    'site_online_payment_gateway',
    'frontend_show_waafi',
    'frontend_show_edahab',
    'frontend_show_premier_wallets',
    'site_default_sms_gateway',
    'site_food_preparation_time',
    'pos_invoice_print_count',
    'receipt_print_method',
    'thermal_printer_name',
    'receipt_paper_preset',
    'receipt_paper_width_mm',
    'theme_logo',
    'fav_icon',
    'footer_logo',
    'default_customer_id',
    'default_payment_method_id',
    'notification_fcm_project_id',
    'notification_firebase_api_key',
    'notification_firebase_auth_domain',
    'notification_firebase_storage_bucket',
    'notification_firebase_messaging_sender_id',
    'notification_firebase_app_id',
    'notification_firebase_measurement_id',
    'notification_firebase_vapid_key',
    'activation_key',
];
